import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// TO DO: rename this component to BaseCheckboxComponent when we remove the old BaseCheckboxComponent
export const BaseCheckboxComponent2 = props => {
  const {
    onChange,
    disabled,
    tooltipTitle,
    isChecked,
    description,
    descriptionLayout,
    children
  } = props;
  const [internalIsChecked, setInternalIsChecked] = useState(isChecked);
  const onCheckboxChange = useCallback(({
    target: {
      checked
    }
  }) => {
    setInternalIsChecked(checked);
    onChange(checked);
  }, [onChange, setInternalIsChecked]);
  useEffect(() => {
    setInternalIsChecked(isChecked);
  }, [isChecked]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(Checkbox, {
      description: description,
      descriptionLayout: descriptionLayout,
      checked: internalIsChecked,
      onChange: onCheckboxChange,
      disabled: disabled,
      "data-test-id": props['data-test-id'],
      children: children
    })
  });
};